module.exports = __webpack_public_path__ + "img/password-change-success.f227fa74.svg";